<template>
  <v-app style="background: black">
    <div v-if="authState != 'signedin'">
      <app-header
        @signIn="
          () => {
            signInClicked = !signInClicked;
            authStateType = authStateTypeSignIn;
          }
        "
        @signUp="
          () => {
            signInClicked = !signInClicked;
            authStateType = authStateTypeSignUp;
          }
        "
      ></app-header>
    </div>
    <div v-if="authState === 'signedin' && user">
      <app-signed-in-header
        @goHome="
          () => {
            goHomeClicked = !goHomeClicked;
          }
        "
        @toggleMap="toggleMap"
        @toggleBadge="toggleBadge"
        :user="user"
        :email="email"
      ></app-signed-in-header>
    </div>

    <v-main>
      <router-view
        :goHomeClicked="goHomeClicked"
        :user="user"
        :email="email"
        :toggleMapClicked="toggleMapClicked"
        :toggleBadgeClicked="toggleBadgeClicked"
      ></router-view>
      <div class="auth">
        <div v-if="authState != 'signedin'">
          <v-card v-if="signInClicked" flat tile>
            <amplify-auth-container>
              <amplify-authenticator
                username-alias="email"
                :initial-auth-state="authStateType"
              >
                <amplify-sign-up
                  header-text="Sign Up for Free"
                  slot="sign-up"
                  username-alias="email"
                  :form-fields.prop="formFields"
                ></amplify-sign-up>
                <amplify-sign-in
                  header-text="Haikubox Sign In"
                  slot="sign-in"
                  :form-fields.prop="signInFields"
                ></amplify-sign-in>
              </amplify-authenticator>
            </amplify-auth-container>
            <v-card-subtitle
              >By continuing, I agree to the Haikubox Terms of Service.
            </v-card-subtitle>

            <router-link
              style="text-decoration: none; color: inherit"
              to="/terms"
            >
              <v-btn>Terms </v-btn>
            </router-link>

            <router-link
              style="text-decoration: none; color: inherit"
              to="/privacy"
            >
              <v-btn>Privacy Policy </v-btn>
            </router-link>
          </v-card>
          <v-img
            height="200px"
            src="https://haikubox-images.s3.amazonaws.com/web/partnerssm.jpeg"
          ></v-img>
        </div>
      </div>
      <div v-if="authState != 'signedin'">
        <v-icon small color="white">mdi-copyright</v-icon
        ><span class="white--text font-weight-light"
          >2024 Loggerhead Instruments, Inc</span
        >
      </div>
      <div v-if="authState === 'signedin' && user">
        <!-- <app-footer></app-footer> -->
        <router-link style="text-decoration: none; color: inherit" to="/">
          <amplify-sign-out></amplify-sign-out>
        </router-link>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import Header from "./components/Header.vue";
// import Footer from "./components/Footer.vue";
import HeaderSignedIn from "./components/HeaderSignedIn.vue";
// import Landing from "./components/Landing.vue";
// import Privacy from "./components/Privacy.vue";
// import Terms from "./components/Terms.vue";
// import Haikumarine from "./Haikumarine.vue"

export default {
  beforeCreate() {
    // console.log('App.vue beforeCreate');
    onAuthUIStateChange((authState, authData) => {
      // console.log('onAuthUIStateChange', authState, authData, this.$route.path);
      this.authState = authState;
      if (authData != undefined) {
        // console.log(authData);
        this.user = authData.username;
        this.email = authData.attributes.email;
        // console.log('user', this.user);
        if (this.$route.path === "/") this.$router.push({ path: "/haikubox" });
      } else {
        this.user = "";
        this.email = "";
        // this is needed for correct login. If try to login from /haikubox it loads last loaded login, not new login.
        if (
          (this.$route.path !== "/") &
          (this.$route.path !== "/settings") &
          (this.$route.path !== "/privacy") &
          (this.$route.path !== "/terms") &
          (this.$route.path !== "/success")
        ) {
          this.$router.push({ path: "/" });
          // console.log("go to landing");
        }
      }
    });
  },
  created() {
    if (this.authState === undefined) {
      Auth.currentAuthenticatedUser().then((authData) => {
        this.authState = AuthState.SignedIn;
        this.user = authData.username;
        this.email = authData.attributes.email;
        // console.log('created, signed in');
        // line below causes duplicate routing error
        // without this line refreshing a page stays on the same page
        // if ((this.$route.path !== '/haikubox') & (this.$route.path !== '/settings') & (this.$route.path !== '/privacy') & (this.$route.path !== '/terms') & (this.$route.path !== '/success')) this.$router.push({ path: "/haikubox" });
      });
    }
  },
  components: {
    appHeader: Header,
    // appFooter: Footer,
    appSignedInHeader: HeaderSignedIn,
    // appLanding: Landing,
    // appPrivacy: Privacy,
    // appTerms: Terms,
    // appHaikumarine: Haikumarine,
  },
  beforeDestroy() {
    return onAuthUIStateChange;
  },
  data() {
    return {
      goHomeClicked: false,
      toggleMapClicked: false,
      toggleBadgeClicked: false,
      user: "",
      email: "",
      authState: undefined,
      authStateType: "signin",
      authStateTypeSignIn: "signin",
      authStateTypeSignUp: "signup",
      signInClicked: true,
      showMarineClicked: false,
      signInFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email",
          required: true,
          handleInputChange: (event, cb) => {
            document
              .querySelector("amplify-sign-in")
              .shadowRoot.querySelector("amplify-input input").value = document
              .querySelector("amplify-sign-in")
              .shadowRoot.querySelector("amplify-input input")
              .value.toLowerCase();
            cb(event);
          },
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password",
          required: true,
        },
      ],
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address",
          required: true,
          handleInputChange: (event, cb) => {
            document
              .querySelector("amplify-sign-up")
              .shadowRoot.querySelector("amplify-input input").value = document
              .querySelector("amplify-sign-up")
              .shadowRoot.querySelector("amplify-input input")
              .value.toLowerCase();
            cb(event);
          },
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password (>7 characters)",
          required: true,
        },
      ],
    };
  },
  methods: {
    toggleMap() {
      this.toggleMapClicked = !this.toggleMapClicked;
      // console.log("App toggle map", this.toggleMapClicked);
    },
    toggleBadge() {
      this.toggleBadgeClicked = !this.toggleBadgeClicked;
      // console.log("App toggle map", this.toggleMapClicked);
    },
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import url("https://fonts.googleapis.com/css?family=Quicksand");
#app {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.auth {
  /* margin: auto auto; */
}
amplify-authenticator {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 60vh;
}
</style>
